import { useRouter } from 'next/router'
import { useState } from 'react'
import { Form } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import {
  INQUIRY_TYPES,
  InquiryType,
  addDoc,
  getInquiryTypeDescription,
  inquiriesRef,
} from '../../firebase'
import { useAuthState } from '../../firebase/hooks'
import { App, Designed } from '../../types'
import { isBlank } from '../../utils'
import { usePopupMessage } from '../messenger'
import { SpinnerButton } from '../spinners'

type Props = {
  app: App
}

export const InquiryForm = ({ app, ...otherProps }: Designed<Props>) => {
  const { user } = useAuthState()
  const { setPopupMessage } = usePopupMessage()
  const {
    register,
    handleSubmit,
    formState: { isValid },
  } = useForm<{
    body: string
    type: InquiryType
    is_requested_reply: boolean
  }>({
    mode: 'onChange',
    reValidateMode: 'onChange',
  })
  const router = useRouter()
  const [isSubmitting, setIsSubmitting] = useState(false)

  return (
    <div {...otherProps}>
      <Form
        className="d-flex flex-column gap-4"
        onSubmit={handleSubmit(async ({ body, type, is_requested_reply }) => {
          if (isBlank(user)) return
          setIsSubmitting(true)
          await addDoc(inquiriesRef, {
            body,
            type,
            is_requested_reply,
            app,
            created_by: user.uid,
          })
          await router.push('/')
          setPopupMessage('お問い合わせを送信しました。')
        })}
      >
        <Form.Group>
          <Form.Label className="fw-bold">お問い合せの種別</Form.Label>
          <div className="d-flex flex-column gap-2">
            {INQUIRY_TYPES.map((type) => (
              <Form.Check
                key={type}
                type="radio"
                {...register('type', {
                  required: true,
                })}
                value={type}
                label={getInquiryTypeDescription(type)}
                id={type}
              />
            ))}
          </div>
        </Form.Group>
        <Form.Group>
          <Form.Label className="fw-bold">お問い合せの内容</Form.Label>
          <Form.Control
            as="textarea"
            rows={8}
            {...register('body', { required: true })}
          />
        </Form.Group>
        <Form.Group>
          <Form.Check
            id="is_requested_reply"
            {...register('is_requested_reply')}
            label="返信を希望する"
          />
          <p className="text-muted small">
            ※{' '}
            返信はMathlogに登録されているメールアドレスにお送りさせて頂きます。
          </p>
        </Form.Group>
        <div>
          <SpinnerButton
            type="submit"
            loading={isSubmitting}
            disabled={!isValid}
          >
            送信
          </SpinnerButton>
        </div>
      </Form>
    </div>
  )
}
